export const BASE_LINKS: {
  icon: string;
  dollarSignIcon?: boolean;
  title: string;
  color: 'yellow' | 'gray';
  link: string;
}[] = [
  {
    icon: 'assets/icons/shared/profile.svg',
    title: 'Support',
    color: 'gray',
    link: 'support',
  },
  {
    icon: 'assets/icons/shared/shield.svg',
    title: 'Fairness',
    color: 'gray',
    link: 'provably-fair',
  },
  {
    icon: 'assets/icons/shared/info.svg',
    title: 'FAQ',
    color: 'gray',
    link: 'faq',
  },
  {
    icon: 'assets/icons/shared/list-with-shield.svg',
    title: 'TOS',
    color: 'gray',
    link: 'tos',
  },
  {
    icon: 'assets/icons/core/skins.svg',
    // icon: 'assets/icons/features/leaderboard.svg',
    // dollarSignIcon: true,
    title: '1500 Leaderboard',
    color: 'yellow',
    link: 'leaderboard',
  },
  {
    icon: 'assets/icons/core/price.svg',
    dollarSignIcon: false,
    title: '6.000 Monthly Raffle',
    color: 'yellow',
    link: 'raffles',
  },
];
